import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  PageSubTitle,
  EmptyState,
  Loading,
  LinkBack
} from 'components/common/Elements/Elements';
import PlatformPoliciesTable from './PlatformPoliciesTable/PlatformPoliciesTable';

import { postRequest } from 'utils/requests';

import classes from './PlatformPolicies.module.scss';

const PlatformPolicies = ({ customerId }) => {
  const [policies, setPolicies] = useState({});
  const [loader, setLoader] = useState(true);
  const [loaderTable, setLoaderTable] = useState(false);
  const [dataConection, setDataConection] = useState(false);
  const [jsonPolicy, setJsonPolicy] = useState([]);

  const { t } = useTranslation('activity');

  useEffect(() => {
    let cancelled = false;
    setLoaderTable(true);
    postRequest('/customer/platform/policies/list', {
      customerId: customerId
    })
      .then(res => {
        if (!cancelled) {
          setPolicies(res.body);
          setLoader(false);
          setLoaderTable(false);
          setDataConection(true);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setLoader(false);
          setLoaderTable(false);
          setDataConection(false);
          console.log(err);
        }
      });
    return () => (cancelled = true);
  }, [customerId]);

  if (loader) {
    return <Loading />;
  }

  const handlePolicies = _id => {
    let cancelled = false;
    postRequest('/customer/platform/policy/info', {
      policyId: _id
    })
      .then(res => {
        !cancelled && setJsonPolicy(res.body);
      })
      .catch(err => {
        !cancelled && console.log(err);
      });
    return () => (cancelled = true);
  };

  return (
    <>
      <div className={classes.header}>
        <PageSubTitle title={t('activity:platform.POLICIES')} />
        <LinkBack text="Platform" />
      </div>
      {dataConection ? (
        policies.length !== 0 ? (
          loaderTable ? (
            <Loading />
          ) : (
            <PlatformPoliciesTable
              tableData={policies}
              jsonPolicy={jsonPolicy}
              handlePolicies={handlePolicies}
            />
          )
        ) : (
          <EmptyState />
        )
      ) : (
        <EmptyState message="connect" />
      )}
    </>
  );
};

PlatformPolicies.propTypes = {
  customerId: PropTypes.string
};
export default PlatformPolicies;
